import { Component, OnInit, Input } from "@angular/core";
import { ApiService } from "../";
import { CompaniesService } from "../../companies/companies.service";
import { ConfigService } from "../../config.service";
import { ProjectsService } from "../../projects/projects.service";

@Component({
  selector: "visibility-component",
  template: require('./visibility.component.html'),
  styles: [require('./visibility.component.scss')]
})
export class VisibilityComponent implements OnInit {
  @Input("item") item: any;
  projects: any[];
  employers: any[];
  countries: any[] = ConfigService.countryList;
  countryCode: string;
  countryCode2: string;
  projectId: string;
  employerId: string;

  constructor(
    private companiesService: CompaniesService,
    private apiService: ApiService,
    private projectsService: ProjectsService
  ) {}

  ngOnInit() {
    this.getProjects();
    this.getEmployers();
  }

  getProjects() {
    this.projectsService
      .getProjectList()
      .subscribe((projects) => (this.projects = projects));
  }

  getEmployers() {
    this.companiesService
      .getEmployers()
      .subscribe((employers) => (this.employers = employers));
  }

  removeListItem(field: string, id: string) {
    let array = this.item.context[field];
    let index = array.indexOf(id);
    if (index > -1) {
      array.splice(index, 1);
    }
  }

  addProject(projectId: string) {
    if (projectId) {
      this.item.context.project_ids.push(projectId);
      this.projectId = null;
    }
  }

  getProjectName(id: string): string {
    return this.projects.filter((item) => {
      return item.id === id;
    })[0].name;
  }

  addNationality(countryCode: string) {
    if (countryCode) {
      this.item.context.nationalities.push(countryCode);
      this.countryCode = null;
    }
  }

  getCountryName(countryCode: string): string[] {
    return ApiService.getCountryNames([countryCode]);
  }

  addEmployer(employerId: string) {
    if (employerId) {
      this.item.context.employer_ids.push(employerId);
      this.employerId = null;
    }
  }

  getEmployerName(employerId: string): string {
    return this.employers.filter((item) => {
      return item.id === employerId;
    })[0].name;
  }

  addCountry(countryCode: string) {
    if (countryCode) {
      this.item.context.countries.push(countryCode);
      this.countryCode2 = null;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/visibility/visibility.component.ts